// extracted by mini-css-extract-plugin
export default {"wrapper":"module-summary_wrapper__P2Elf","item":"module-summary_item__HcjTV"};